var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "002-twitter",
    clipPath: "url(#clip0_1247_6257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.4714 21.2488L33.373 35.4116H29.3093L21.2294 23.8547V23.854L20.0432 22.1575L10.6045 8.65625H14.6681L22.2851 19.5523L23.4714 21.2488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.2457 0H4.75429C2.12864 0 0 2.12864 0 4.75429V39.2457C0 41.8714 2.12864 44 4.75429 44H39.2457C41.8714 44 44 41.8714 44 39.2457V4.75429C44 2.12864 41.8714 0 39.2457 0ZM28.0646 37.3129L19.8882 25.4131L9.65131 37.3129H7.00557L18.7134 23.7041L7.00557 6.66455H15.9354L23.6779 17.9328L33.3715 6.66455H36.0172L24.853 19.6422H24.8523L36.9944 37.3129H28.0646Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_6257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterColor);
export default __webpack_public_path__ + "static/media/twitter-color.10b0618361be0a4aac1fbe4f31d764b6.svg";
export { ForwardRef as ReactComponent };